<template>
  <div class="EnbNave02">
    <div class='cont-EnbNave02'
    :style="{ 
      backgroundColor: Prefes.nave.corBackground,
      fontFamily: Prefes.nave.font,
      color: Prefes.nave.corFont,
      fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
      fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
      textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
      fontSize: Prefes.nave.fontHeight + 'px',
      width: !pref ? '100%' : '72.2%'
    }"
    >
      <enb-categ v-if="showCateg"
      @mouseenter="showCateg=true"
      @mouseleave="showCateg=false"
      />
      <div class="cont-nave"
      :style="{ width: !pref ? '80%' : '98%' }"
      >
        <enb-logo02/>
        <enb-link02
        v-for="(link, key) in LinksTheme01"
        :key="key"
        :data="link"
        v-model:showCateg="showCateg"
        />
        <enb-search02/>
        <link-profile02
        @click="login"
        :style="{ color: Prefes.nave.corFont }"
        />
        <div class="cont-bag"
        @mouseenter="showBag=true"
        >
          <component
          :is="Prefes.cart.icon"
          :color="Prefes.cart.corFont"
          :tam="'40px'"
          :count="false"
          @mouseenter="showBag=true"
          :style="{ color: Prefes.nave.corFont }"
          />
          <div v-if="CheckoutItens01.length">({{ CheckoutItens01.length }})</div>
          <enb-bag02
          v-if="showBag"
          @mouseenter="showBag=true"
          @mouseleave="showBag=false"
          />
        </div>
      </div>
    </div>
    <div class="cont-ajuste"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbLogo02 from './EnbLogo02'
import EnbSearch02 from './EnbSearch02'
import EnbLink02 from './EnbLink02'
import LinkProfile02 from './LinkProfile02'
import BagIcon from '@/components/Theme01/Icons/BagIcon'
import EnbBag02 from '@/components/Theme01/Bag/EnbBag02'
import EnbCateg from './EnbCateg'
import { icons } from '@/components/icons'
export default {
  name: 'EnbNave02',
  components: { EnbLogo02, EnbSearch02, EnbLink02, BagIcon, LinkProfile02, EnbBag02, EnbCateg, ...icons },
  props: {
    pref: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['LinksTheme01', 'CheckoutItens01', 'Profile', 'Prefes'])
  },
  data () {
    return {
      showBag: false,
      showCateg: false
    }
  },
  methods: {
    ...mapActions(['SetModal01', 'GetCategory']),
    login() {
      if(Object.keys(this.Profile).length) {
        this.$router.push('/profile')
      } else {
        this.SetModal01({ component: 'EnbLogin01', active: true, barText: 'login' })
      }
    }
  },
  created () {
    this.GetCategory()
  }
}
</script>

<style scoped>
.EnbNave02 {
  width: 100%;
  height: 70px;
}

.cont-ajuste {
  width: 100%;
  height: 70px;
}

.cont-EnbNave02 {
  width: 100%; /* 100% */ 
  height: 70px;
  position: absolute;
  background-color: #FFFFFF ;
  border-bottom: thin solid #CCCCCC;
  z-index: 100;
}

.cont-nave {
  width: 80%; /* 80% */
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  margin: auto;
  color: #666666
}

.cont-bag {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-left: 1%;
  padding-right: 1%;
}

@media (max-width: 500px) {
  .EnbNave02 {
    display: none;
  }
}
</style>
